"use strict";
var ACC;
ACC.order = {

	_autoload: [
	    "backToOrderHistory",
	    "backToOrders",
		"accountRemoveAddress",
		["bindAccountViewOrderHandler", $("ul.account-orderhistory-list li").length],
		["expiredCreditCard", $(".account-savedcards-expired").length]
	],

	backToOrderHistory: function(){
		$(".orderBackBtn").on("click", function(){
			var sUrl = $(this).data("backToOrders");
			window.location = sUrl;
		});
	},
	backToOrders: function(){
		$(".orderTopBackBtn").on("click", function(){
			var sUrl = $(this).data("backToOrders");
			window.location = sUrl;
		});
	},

	accountRemoveAddress: function(){
		$(".account-address-removelink").on("click", function(){
			$('.global-message-container').hide();
		});

		if($('.global-alerts .confirmation-message').length){
			$('.account-section-global-message').show();
		}
	},

	bindAccountViewOrderHandler: function(){
		$('ul.account-orderhistory-list .order').click(function(){
			var alterClickArea = Modernizr.mq('(max-width: 640px)');
			var accountLink = $(".account-orderhistory-link", this).prop("href");
			if(alterClickArea) {
				window.location = accountLink;
			}
		});
	},

	expiredCreditCard: function(){
		$('.account-savedcards-expired').parent().parent().addClass('account-expired-card');
	}


};
